import { useLocation, useNavigate, NavigateOptions } from 'react-router-dom';

const useNavigateWithQuery = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  return (to: string, config?: NavigateOptions) => navigate(to + search, config);
};

export default useNavigateWithQuery;
